<template>
    <audio ref="audioPlayer" class="hidden" :src="audioUrl"></audio>
  </template>

  <script>
  export default {
    name: 'LoadingAudioPlayer',

    props: {
      isResponseInProgress: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      audioUrl() {
        return `https://${window.location.host}/static/Odyssey-Eveningland.mp3`;
      }
    },

    watch: {
      isResponseInProgress: {
        immediate: true,
        handler(newValue) {
          if (newValue) {
            this.playAudio();
          } else {
            this.stopAudio();
          }
        }
      }
    },

    methods: {
      playAudio() {
        if (this.$refs.audioPlayer) {
          this.$refs.audioPlayer.volume = 0.1;
          this.$refs.audioPlayer.loop = true;
          const playPromise = this.$refs.audioPlayer.play();

          if (playPromise !== undefined) {
            playPromise.catch(error => {
              console.warn('Audio playback failed:', error);
            });
          }
        }
      },

      stopAudio() {
        const player = this.$refs.audioPlayer;
        if (player) {
          player.pause();
          player.currentTime = 0;
        }
      }
    },

    beforeDestroy() {
      this.stopAudio();
    }
  }
  </script>
